import { render, staticRenderFns } from "./gamerule.vue?vue&type=template&id=49a5f2e2&"
import script from "./gamerule.vue?vue&type=script&lang=js&"
export * from "./gamerule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports